import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('agreement/list', { params });
  },
  async add(params: any) {
    return axios.post('agreement/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('agreement/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('agreement/detail', { params });
  },
  async delete(params: any) {
    return axios.post('agreement/delete', qs.stringify(params));
  },
  async records(params: any) {
    return axios.get('agreement/records', { params });
  },
  async audit(params: any) {
    return axios.post('agreement/audit', qs.stringify(params));
  },
  async items(params: any) {
    return axios.get('agreement/items', { params });
  },
  async additem(params: any) {
    return axios.post('agreement/additem', qs.stringify(params));
  },
  async edititem(params: any) {
    return axios.post('agreement/edititem', qs.stringify(params));
  },
  async detailitem(params: any) {
    return axios.get('agreement/detailitem', { params });
  },
  async deleteitem(params: any) {
    return axios.post('agreement/deleteitem', qs.stringify(params));
  },
  async versions(params: any) {
    return axios.get('agreement/versions', { params });
  },
  async copyNew(params: any) {
    return axios.post('agreement/copy-new', qs.stringify(params));
  },
};
